import { useEffect } from "react";
import * as React from "react";
import { Header } from "../components/Header";

export const NewEvent = () => {
  const events = [
    { image: "/landingPage_banner/event03.png" },
    { image: "/landingPage_banner/step3-event2.png" },
    { image: "/landingPage_banner/step4-event1.png" },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="w-screen bg-white flex flex-col items-center justify-center">
        <Header />
        <img
          src="/banners/banner-karyakram-batmya.jpg"
          alt="Event Banner"
          className="w-full object-cover shadow-lg"
        />
      </div>

      <div className="max-w-6xl mx-auto mt-10">
        <div className="flex items-center justify-center flex-col gap-6">
          {events.map((data, index) => (
            <div key={index} className="relative">
              <img
                src={data.image}
                alt={`Event ${index + 1}`}
                className="rounded-xl"
              />
              <button className="absolute bottom-4 left-4 hover:bg-orange-500 bg-orange-600 font-bold text-black rounded-xl py-2 px-5">
                Register Here
              </button>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
